// src/services/dashboardService.js - SECURED
import { API_BASE_URL } from '../utils/constants';


const getAuthHeaders = (contentType = 'application/json') => {
  return {
    'Content-Type': contentType,
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    if (response.status === 401) {
      window.location.href = '/';
    }
    const error = await response.json();
    throw new Error(error.error || error.detail || 'Request failed');
  }
  return response.json();
};

export const dashboardService = {
  async getWalletBalance() {
    try {
      const url = `${API_BASE_URL}/users/wallet/balance/`;
      
      console.log('📊 Fetching wallet balance from:', url);
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      const data = await handleResponse(response);
      console.log('💰 Wallet data received:', data);
      console.log('💱 Currency from API:', data.currency);
      
      // Return the data as-is, preserving the currency from backend
      const walletData = {
        balance: parseFloat(data.balance) || 0,
        availableBalance: parseFloat(data.available_balance) || parseFloat(data.balance) || 0,
        reservedBalance: parseFloat(data.reserved_balance) || 0,
        currency: data.currency || 'NGN' // Use currency from backend
      };
      
      console.log('📤 Returning wallet data:', walletData);
      
      return walletData;
    } catch (error) {
      console.error('💥 Error fetching wallet balance:', error);
      throw error;
    }
  },

  async getTrendingStocks() {
    try {
      const url = `${API_BASE_URL}/stocks/trending/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('💥 Error fetching trending stocks:', error);
      throw error;
    }
  },

  async getPortfolio() {
    try {
      const url = `${API_BASE_URL}/stocks/holdings/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      return await handleResponse(response);
    } catch (error) {
      console.error('💥 Error fetching portfolio:', error);
      throw error;
    }
  },

  async getInvestmentPlans() {
    try {
      const url = `${API_BASE_URL}/investment/list/`;
      
      const response = await fetch(url, {
        method: 'GET',
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      
      const data = await handleResponse(response);
      return data.results || data;
    } catch (error) {
      console.error('💥 Error fetching investment plans:', error);
      return [];
    }
  },
};